import { Formik, Form, FormikProps, FormikHelpers } from 'formik'
import { Panel, ButtonToolbar, Col } from 'rsuite'
import { Button, Modal, Row, TextInput, FormikErrorMessage } from 'shared'
import { useMemo, useState } from 'react'
import { notifyError } from 'utils'
import { Currency, orderPaymentDetails } from '../types'
import {
  defaultPaymentFormValues,
  getInitialPaymentFormValuesResponse,
  PAYMENT_FORM_FIELDS,
  PaymentForm,
  paymentValidationSchema
} from '../utils'
import { useCreateOrderMutation } from '../walletApiSlice'
import RenderRazorpay from './rendorRazorpay'
import '../wallet/wallet.scss'

interface PaymentProps {
  open: boolean;
  onClose: () => void;
}
const Payment: React.FC<PaymentProps> = ({ open, onClose }) => {
  const { AMOUNT } = PAYMENT_FORM_FIELDS
  const initialValues = useMemo(() => defaultPaymentFormValues, [])
  const [orderDetails, setOrderDetails] = useState<orderPaymentDetails | null>(
    null
  )
  const [displayRazorpay, setDisplayRazorpay] = useState(false)
  const [CreateOrder] = useCreateOrderMutation()
  const handlePaymentSuccess = () => {
    onClose()
  }

  const onSubmit = async (
    formValues: PaymentForm,
    { setSubmitting }: FormikHelpers<PaymentForm>
  ) => {
    const payload = {
      amount: formValues.amount
    }
    try {
      const response = await CreateOrder(payload).unwrap()

      if (response && response.id) {
        setOrderDetails({
          orderId: response?.id,
          currency: response?.currency || Currency.INR,
          amount: formValues?.amount
        })
        setDisplayRazorpay(true)
      }
    } catch (error) {
      notifyError('Error Create Order', { containerId: 'modalToast' })
    }
  }

  const renderFormButtons = (formikProps: FormikProps<PaymentForm>) => (
    <ButtonToolbar>
      <>
        <Button
          className="formButton-wallet"
          id="reset"
          onClick={() => {
            onClose()
          }}
        >
          Back
        </Button>
        <Button
          className="formButton-wallet"
          type="submit"
          appearance="primary"
          disabled={formikProps.isValidating || formikProps.isSubmitting}
        >
          Add Money
        </Button>
      </>
    </ButtonToolbar>
  )
  return (
    <div>
      <Modal
        secondary
        open={open}
        onClose={onClose}
        title="Amount"
        size="calc(40% - 90px)"
        body={
          <div>
            <Formik
              initialValues={getInitialPaymentFormValuesResponse(initialValues)}
              validationSchema={paymentValidationSchema}
              onSubmit={onSubmit}
            >
              {(formikProps: FormikProps<PaymentForm>) => (
                <Form className="create-amount">
                  <Panel>
                    <Row>
                      <Col xs={18}>
                        <TextInput
                          id={PAYMENT_FORM_FIELDS.AMOUNT}
                          formik={formikProps}
                          name={AMOUNT}
                          placeholder="Enter Amount"
                        />
                        <FormikErrorMessage name="amount" />
                      </Col>
                    </Row>
                  </Panel>
                  <Panel className="panel-buttons">
                    {renderFormButtons(formikProps)}
                  </Panel>
                </Form>
              )}
            </Formik>
          </div>
        }
      />
      {displayRazorpay && (
        <RenderRazorpay
          amount={orderDetails?.amount ? parseFloat(orderDetails?.amount) : 0}
          currency={orderDetails?.currency || 'INR'}
          orderId={orderDetails?.orderId || ''}
          keyId={process.env.REACT_APP_RAZORPAY_KEY_ID ?? ''}
          keySecret={process.env.REACT_APP_RAZORPAY_KEY_SECRET ?? ''}
          onSuccess={handlePaymentSuccess}
        />
      )}
    </div>
  )
}
export default Payment
